// Removes stray LLM chat-protocol delimiter lines (---ANSWER---, ---CONTENT---, etc.),
// including tokens with trailing dashes lost to output truncation (e.g. "---CONTENT").
const DELIMITER_LINE_REGEX = /^[ \t]*---(?:ANSWER|UPDATE_CHAPTER|NOTES|CONTENT|ERROR)-{0,3}[ \t]*\r?$/;

export const stripDelimiterLines = (content: string): string => {
  if (!content.includes("---")) {
    return content;
  }
  return content
    .split("\n")
    .filter((line) => !DELIMITER_LINE_REGEX.test(line))
    .join("\n");
};
